import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export const Template = ({
  className = '',
  fill = colors.boulder,
  size = 14,
  title = 'Template',
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;
  const dValue =
    'M9.87,0H1.12A1.12,1.12,0,0,0,0,1.12H0V9.88A1.12,1.12,0,0,0,1.12,11H9.88A1.12,1.12,0,0,0,11,9' +
    '.88V1.12A1.12,1.12,0,0,0,9.88,0Zm0,1.15V4.41H1.15V1.15ZM1.15,5.7H5.79V9.84H1.15ZM7.08,9.84V5' +
    '.69H9.84V9.84Z';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 11 11"
      className={className}
    >
      {Boolean(title) && <title>{title}</title>}
      <path d={dValue} fill={fill} />
    </svg>
  );
};
